var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`a-button-primary ${_vm.buttonClass}`,attrs:{"type":_vm.buttonPrimary.type}},[_c('i',{class:[_vm.buttonPrimary.sending
    ? 'far fa-spinner fa-spin' : _vm.buttonIcon
    , 'margin-right-xsmall']}),_c('span',[_vm._v(_vm._s(_vm.buttonPrimary.action))])])
}
var staticRenderFns = []

export { render, staticRenderFns }